import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import lupeIcon from '@web/utils/src/assets/icons/functions/lupe.svg';
import plusIcon from '@web/utils/src/assets/icons/functions/plus-icon.svg';

export interface SearchBarProps {
  placeholder?: string;
  className?: string;
  variant?: 'thin' | 'thick';
  searchTerm?: string;
  setSearchTerm(searchTerm: string): void;
}

const SearchBar = (props: SearchBarProps) => {
  const [searchValue, setSearchValue] = useState<string>(
    props.searchTerm || '',
  );
  const { i18n } = useTranslation();

  const {
    placeholder = '',
    variant = 'thick',
    className = '',
    setSearchTerm,
  } = props;

  const handleSearch = (e: any) => {
    e.preventDefault();
    if (e.nativeEvent.submitter.value === 'clear') {
      setSearchValue('');
      setSearchTerm('');
      return;
    }
    setSearchTerm(searchValue);
  };

  return (
    <form
      className={clsx(className, 'relative w-full')}
      onSubmit={handleSearch}
    >
      <input
        className={clsx(
          variant === 'thick' ? 'p-2-0' : 'p-1-5',
          'w-full mb-0 block appearance-none rounded-4-0 bg-secondary-grey bg-opacity-50  pl-8-0 pr-8-0 md:pl-6-0 text-2-5 md:text-1-6 leading-1-0 text-primary-black focus:outline-none',
        )}
        placeholder={
          placeholder || (i18n.t('search_bar.placeholder') as string)
        }
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      <button type="submit" onSubmit={handleSearch}>
        <img
          src={lupeIcon}
          alt="Search"
          className={clsx(
            variant === 'thick' ? 'left-2-0 top-2-0' : '',
            'absolute left-1-5 top-1-5 w-2-0 h-2-0',
          )}
        />
      </button>
      <button type="submit" onSubmit={handleSearch} value="clear">
        <img
          src={plusIcon}
          alt="clear"
          className={clsx(
            variant === 'thick' ? 'right-2-0 top-2-2' : '',
            'absolute right-1-5 top-1-5 w-1-5 h-1-5 opacity-40 transform rotate-45',
          )}
        />
      </button>
    </form>
  );
};

export default SearchBar;
